import { render, staticRenderFns } from "./DesignExperimentResults.vue?vue&type=template&id=dca1c908&scoped=true"
import script from "./DesignExperimentResults.vue?vue&type=script&lang=js"
export * from "./DesignExperimentResults.vue?vue&type=script&lang=js"
import style0 from "./DesignExperimentResults.vue?vue&type=style&index=0&id=dca1c908&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca1c908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dca1c908')) {
      api.createRecord('dca1c908', component.options)
    } else {
      api.reload('dca1c908', component.options)
    }
    module.hot.accept("./DesignExperimentResults.vue?vue&type=template&id=dca1c908&scoped=true", function () {
      api.rerender('dca1c908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeScope2Design/DesignExperimentResults.vue"
export default component.exports